import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useInfiniteQuery, useQuery } from 'react-query';
import { JobsPharmaJobs } from 'services/pharmaJobs';
import { getSkillInsights } from 'services/cv';

import JobsFilters from './jobsfilters/JobsFilters';
import JobsList from './jobslist/JobsList';
import JobDetails from './jobdetails/JobDetails';
import Spinner from '@core/components/spinner/Spinner';
import Modal from '@core/components/Modal/Modal';
import ResumeAnalyzerBanner from 'components/pages/jobs/resumeanalyzerbanner/ResumeAnalyzerBanner';


import UseModal from 'hooks/use-modal';
import useWindowSize from 'hooks/use-windowSize';
import UseToast from 'hooks/use-toast';

import { getAccessToken } from 'utils/authentication';
import { Pagination } from '@mui/material';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import EmptyJobPost from 'assets/icons/folder-2-crossed.svg';
import BackButton from '@core/assets/icons/simple-back.svg';

import classes from './JobsWrapper.module.scss';


const JobsWrapper = () => {
    const router = useRouter();
    const [startPage, setStartPage] = useState(1);
    const { mobileDevice } = useWindowSize();
    const [activeJob, setActiveJob] = useState('');
    const { toast, ToastContainer } = UseToast();
    const { destroyModal, show, showModal } = UseModal();
    const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage, refetch } = useInfiniteQuery(
        [
            'pharma-jobs-jobs',
            getAccessToken(),
            router?.query?.search_keyword,
            router?.query?.location,
            router?.query?.employment_type,
            router?.query?.job_mode,
            router?.query?.job_level,
            router?.query?.date_posted,
            router?.query?.favorite
        ],
        ({ pageParam = 1 }) => JobsPharmaJobs.GET({ ...router?.query, page: startPage, page_size: 10 }),
        {
            getNextPageParam: (lastpage, pages) => {
                if (lastpage.data?.next) {
                    return pages.length + 1;
                }
                return;
            },
            enabled: router.isReady,
            onSuccess: (d) => {
                // console.log('aa', d);
            }
        }
    );

    const { data: skillInsights } = useQuery('skill-insights', getSkillInsights);

    const filterChangeHandler = (newFilters) => {
        const newQueryFilters = Object.keys(newFilters).reduce((queries, currentKey) => {
            const currentValue = newFilters[currentKey];
            if (currentValue && currentValue !== '') {
                return { ...queries, [currentKey]: currentValue };
            } else {
                return queries;
            }
        }, {});
        router.replace(
            {
                query: { ...newQueryFilters }
            },
            undefined,
            { shallow: true }
        );
        setStartPage(1);
    };
    const handlePageChange = (newPage) => {
        setStartPage(newPage);
    };
    const jobsArray = data?.pages?.reduce((finalArray, currentPage) => {
        if (currentPage?.data?.results) {
            if (currentPage?.data?.results?.length > 0 && !activeJob) {
                setActiveJob(currentPage?.data?.results[0].id);
            }
            return [...finalArray, ...currentPage.data.results];
        } else {
            return finalArray;
        }
    }, []);

    useEffect(() => {
        refetch();
    }, [startPage]);

    useEffect(() => {
        if (jobsArray?.length === 0 && activeJob) {
            setActiveJob('');
        }
    }, [jobsArray?.length]);

    useEffect(() => {
        if (router?.query?.active_job) {
            setActiveJob(router.query.active_job);
        }
    }, [router?.query?.active_job]);

    const jobClickHandler = (jobId) => {
        setActiveJob(jobId);
        let newUrl = '/job-board'
        if (mobileDevice) {
            router.push(router.asPath + '#job-detail', null, { shallow: true })
            // window.history.replaceState({ ...window.history.state, as: newUrl, url: newUrl }, '', newUrl);
            showModal();
        }
    };

    if (typeof window !== "undefined") {
        window.addEventListener('popstate', function (event) {
            destroyModal();
        }, false);
    }

    const jobDetailsCloseHandler = () => {
        destroyModal();
        router.back();
    }
    return (
        <>
            <div className={`${classes['job-board-wrapper']} w-100 d-flex flex-column`}>
                <JobsFilters filterChangeHandler={filterChangeHandler} toast={toast} />
                {/* <ResumeAnalyzerBanner /> */}
                {!isLoading && data && skillInsights ? (
                    jobsArray?.length !== 0 ? (
                        <>
                            <div className="container">
                                <div className="w-100 d-flex flex-row row my-5">
                                    <div className="d-flex flex-column gap-2 col-12 col-md-5 col-xl-4">
                                        <div className={classes['jobs-list-wrapper']}>
                                            <JobsList
                                                jobs={jobsArray}
                                                isFetchingNextPage={isFetchingNextPage}
                                                fetchNextPage={fetchNextPage}
                                                hasNextPage={hasNextPage}
                                                onJobClick={jobClickHandler}
                                                activeJob={activeJob}
                                                toast={toast}
                                            />
                                        </div>
                                        {jobsArray && data?.pages[0].data.count > 10 && (
                                            <div className="d-flex align-items-center justify-content-center pb-lg-0 mb-5">
                                                <Pagination
                                                    count={Math.ceil(data?.pages[0].data.count / 10)}
                                                    page={startPage ? +startPage : 1}
                                                    variant="outlined"
                                                    shape="rounded"
                                                    color="primary"
                                                    onChange={(e, page) => {
                                                        handlePageChange(page);
                                                        window.scrollTo(0, 0);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-none d-md-block col-md-7 col-xl-8">
                                        <JobDetails activeJob={activeJob} toast={toast} skillInsights={skillInsights?.data} />
                                    </div>
                                </div>
                            </div>
                            <Modal title='Job Details' closeIcon={<BackButton />} closeHandler={jobDetailsCloseHandler} show={show} type={MOBILE_FULLSCREEN}>
                                <JobDetails activeJob={activeJob} toast={toast} skillInsights={skillInsights?.data} />
                            </Modal>
                        </>
                    ) : (
                        <div
                            className={`${classes['jobposts-empty-wrapper']} d-flex flex-column gap-3 align-items-center justify-content-center my-3 my-md-5 py-1 py-md-3`}>
                            <EmptyJobPost />
                            <h5>No job posted yet.</h5>
                        </div>
                    )
                ) : (
                    <div className={classes['loading']}>
                        <Spinner />
                    </div>
                )}
            </div>
            <ToastContainer />
        </>
    );
}

export default JobsWrapper;

